import React from 'react'
import { connect } from 'react-redux'
import { compose, withState, /*lifecycle*/} from 'recompose'
import { FormattedMessage } from 'react-intl'

import PaymentMethod from './Method'
import GiftCardsMethod from './GiftCardsMethod'

import numeral from 'numeral'

const PaymentMethods = ({ methods = [], onChange, sendBack,  bidInputFocus,  setBidInputFocus, fromProfile, fromPage, useGiftCard, 
  giftCardChecked, setGiftCardChecked, checkProps = {}, bidValue, bidCount = 1, giftCardShow, setGiftCardShow, agreementOffer,
setAgreementOffer, setAgreementGiftcard, agreementGiftcard}) => {

  return(methods.length === 0 ? null : (
  <div>
    <h1 className='Signin__title-paymentMethods Head'>
      <FormattedMessage id='bid.select_payment' />{fromPage === 'auction' && '*'}
    </h1>    
    <div className='Payments'>
      {true && !fromProfile && <GiftCardsMethod name="giftcards" onChange={onChange} sendBack={sendBack} bidInputFocus={bidInputFocus} 
      setBidInputFocus={setBidInputFocus} useGiftCard={useGiftCard} giftCardChecked={giftCardChecked} setGiftCardChecked={setGiftCardChecked} 
      giftCardShow={giftCardShow} setGiftCardShow={setGiftCardShow}
      setAgreementGiftcard={setAgreementGiftcard} giftcardBalance={checkProps.balance}/>}
      {((checkProps.balance !== 0) && checkProps.balance && bidValue && giftCardChecked) && 
      <div className='Payments__message'>{numeral((checkProps.balance >= (bidValue * Number(bidCount))) ? (bidValue * Number(bidCount)) : checkProps.balance).format('0,0')} руб. 
      будут списаны с сертификата, {numeral((checkProps.balance >= (bidValue * Number(bidCount))) ? 0 : ((bidValue * Number(bidCount)) - checkProps.balance)).format('0,0')} руб. будут списаны с банковской карты.</div>}
      {(checkProps.balance === 0) && giftCardChecked && <div className='Payments__message'><FormattedMessage id='bid.zero_giftcard' /></div>}
      {checkProps.error && giftCardChecked && <div className='Payments__message'><FormattedMessage id='bid.invalid_giftcard' /></div>}
      {methods.map(methodName => (
        <PaymentMethod name={methodName} key={`payment-${methodName}`} onChange={onChange}/>
      ))}      
      <div className="GiftCardPayment__checkbox">
        <div className="GiftCardPayment__checkbox">
          <input className="custom-checkbox" type="checkbox" id="offer" name="offer" value={agreementOffer}
           onChange={()=>setAgreementOffer(!agreementOffer)}
           checked={agreementOffer}/>
          <label htmlFor="offer">Соглашаюсь с условиями <a href="/help/offer"> Оферты</a></label>
        </div>
        {giftCardChecked && <div className="GiftCardPayment__checkbox">
          <input className="custom-checkbox" type="checkbox" id="giftcard" name="giftcard" value={agreementGiftcard} 
          onChange={()=>setAgreementGiftcard(!agreementGiftcard)} checked={agreementGiftcard}/>
          <label htmlFor="giftcard">Соглашаюсь с <a href="/giftcards/rules"> Правилами пользования сертификатом</a></label>
        </div>}
      </div>
      {fromPage === 'auction' && <div className='Payments__text_xs'><FormattedMessage id='bid.charge_only_win_bid' /></div>}
    </div>
  </div>
))}

const mapState = state => {
  let methods = Object.keys(state.paymentMethods.methods)
  //methods.push('giftcards')
  return {
    methods: methods//Object.keys(state.paymentMethods.methods)
  }
}

export default compose(connect(mapState),
withState('giftCardShow', 'setGiftCardShow', false),
)(PaymentMethods)




// WEBPACK FOOTER //
// ./src/components/Lot/PaymentSelect/index.js